export const composeProtectButton = "I7a";
export const composeSetPermissionDropDown = "J7a";
export default {composeProtectButton,composeSetPermissionDropDown};